module.exports = __webpack_public_path__ + "static/media/crayon.6d53ad20.svg";